import { Outlet } from 'react-router-dom';

export default function AuthLayout() {
    return (
        <div className="flex min-h-screen items-center justify-center bg-slate-950 px-4">
            <div className="w-full max-w-sm">
                <div className="mb-8 text-center">
                    <h1 className="text-2xl font-bold text-violet-400">DebtBound</h1>
                    <p className="text-sm text-slate-400">Debt contract management</p>
                </div>
                <Outlet />
            </div>
        </div>
    );
}
